var _path, _path2, _path3, _path4, _path5, _line, _line2, _line3, _line4, _line5, _line6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaucet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "faucet",
    fill: "none",
    viewBox: "0 0 30 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0.41797 25.916h29.165",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1.4282 25.772c0.46201-0.6931 2.0213-2.8876 2.7432-3.8983h7.6521l2.7432 3.8983",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.969 22.163v-14.438c-0.0817-1.7016 0.2888-3.032 2.4544-3.032h6.4971c1.7326 0 1.8769-3.6096 0-3.6095h-13.427c-2.4544 0-3.2955 1.1965-3.1763 3.032v18.047",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m12.113 9.169h12.561c0.9626 0.14437 2.8876 1.155 2.8876 4.0426 0-0.1156-10.299-0.0482-15.448 0",
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m20.631 13.211v2.4545h5.4864v-2.4545",
    stroke: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25.173,
    x2: 25.173,
    y1: 16.099,
    y2: 17.542,
    stroke: "currentColor"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 24.019,
    x2: 24.019,
    y1: 16.676,
    y2: 18.12,
    stroke: "currentColor"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 25.173,
    x2: 25.173,
    y1: 17.831,
    y2: 19.275,
    stroke: "currentColor"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 22.863,
    x2: 22.863,
    y1: 16.099,
    y2: 17.542,
    stroke: "currentColor"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 25.173,
    x2: 25.173,
    y1: 17.831,
    y2: 19.275,
    stroke: "currentColor"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 4.1719,
    x2: 11.968,
    y1: 7.2246,
    y2: 7.2246,
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaucet);
export default __webpack_public_path__ + "static/media/faucet.72947aca170fc391d49a4c253c46e1e1.svg";
export { ForwardRef as ReactComponent };